import { FC } from 'react';
import { StyledButton } from 'components/Buttons/RefuseButton/style';
import DangerIcon from 'components/SahamIcons/DangerIcon';

export interface RefuseButtonProps {
  title: string;
  onClick: Function;
}

const RefuseButton: FC<RefuseButtonProps> = ({ title, onClick }) => {
  return (
    <StyledButton
      startIcon={<DangerIcon />}
      data-testid={'refuse-button'}
      onClick={() => onClick()}
    >
      {title}
    </StyledButton>
  );
};

export default RefuseButton;
